<div class="container scroll-bar" [ngClass]="{ 'light-mode': !isDarkMode(), 'dark-mode': isDarkMode() }">

  <p class="title">
    Environmental Performance Module
    <mat-icon class="titleIcon">chevron_right</mat-icon> IMO DCS
  </p>

  <div class="filter-header" style="margin-top: 25px;">

    <!-- Quick Selection -->
    <div class="quick-pick-section">
      <span class="section-label">Quick Selection</span>
      <div class="chip-container">
        <button type="button" *ngFor="let period of quickPeriods" class="period-chip"
          [class.ytd-chip]="period === 'YTD'" [class.active]="selectedPeriod === period"
          (click)="quickSelect(period)">
          {{ period }}
        </button>
      </div>
    </div>

    <form [formGroup]="myreportForm" class="filter-flex-container">

      <!-- Client Name (Meraki Only) -->
      <mat-form-field *ngIf="username === 'Meraki - Operations'" appearance="outline" floatLabel="always"
        class="compact-field">
        <mat-label>Client Name</mat-label>
        <mat-select formControlName="client" placeholder="Select Client">
          <mat-option value="">All Clients</mat-option>
          <mat-option *ngFor="let c of clientList" [value]="c">{{ c }}</mat-option>
        </mat-select>
      </mat-form-field>

      <!-- Vessel Name (Multi-select) -->
      <mat-form-field appearance="outline" floatLabel="always" class="compact-field">
        <mat-label>Vessel Name</mat-label>
        <mat-select formControlName="vesselname" placeholder="Select Vessels" multiple>
          <mat-option *ngFor="let ship of vesselNameSuggestions" [value]="ship.ship_name">
            {{ ship.ship_name }}
          </mat-option>
        </mat-select>
      </mat-form-field>

      <!-- Vessel IMO -->
      <mat-form-field appearance="outline" floatLabel="always" class="compact-field">
        <mat-label>Vessel I.M.O</mat-label>
        <input matInput formControlName="vesselIMO" placeholder="Enter IMO">
      </mat-form-field>

      <!-- Date Range -->
      <mat-form-field appearance="outline" floatLabel="always" class="compact-field date-field">
        <mat-label>From Date</mat-label>
        <input matInput [matDatepicker]="fromPicker" formControlName="fromDate" placeholder="Select Date"
          (dateChange)="selectedPeriod = ''">
        <mat-datepicker-toggle matIconSuffix [for]="fromPicker"></mat-datepicker-toggle>
        <mat-datepicker #fromPicker></mat-datepicker>
      </mat-form-field>

      <mat-form-field appearance="outline" floatLabel="always" class="compact-field date-field">
        <mat-label>To Date</mat-label>
        <input matInput [matDatepicker]="toPicker" formControlName="toDate" placeholder="Select Date"
          [min]="myreportForm.get('fromDate')?.value" (dateChange)="selectedPeriod = ''">
        <mat-datepicker-toggle matIconSuffix [for]="toPicker"></mat-datepicker-toggle>
        <mat-datepicker #toPicker></mat-datepicker>
      </mat-form-field>

      <button mat-flat-button color="warn" class="fetch-btn clear-btn" (click)="clearClick()">
        Clear
      </button>

      <button mat-flat-button color="primary" class="fetch-btn" (click)="filterClick()">
        Apply Filter
      </button>

    </form>
  </div>

  <!-- TABLE -->
  <div class="table-container scroll-bar" [ngClass]="{ 'dark-table': isDarkMode() }">
    <table class="mat-elevation-z8 printable-table" id="style-4" matSort>


      <thead class="sticky-header">

        <!-- MAIN HEADER -->
        <tr>
          <th rowspan="3" mat-sort-header="sNo">S.No</th>

          <th rowspan="3" mat-sort-header="vessel_name">Vessel Name</th>
          <th rowspan="3" *ngIf="isMeraki" mat-sort-header="start_date">Start Date</th>
          <th rowspan="3" mat-sort-header="imo_no">IMO No</th>
          <th rowspan="3" mat-sort-header="vessel_type">Vessel Type</th>
          <th rowspan="3" mat-sort-header="segment">Segment</th>

          <th rowspan="3" mat-sort-header="gross_tonnage">Gross Tonnage</th>
          <th rowspan="3" mat-sort-header="deadweight">Deadweight</th>
          <th rowspan="3" mat-sort-header="ice_class">Ice Class</th>

          <th rowspan="3" mat-sort-header="eeoi">
            EEOI <br> (gCO₂ / t.nm)
          </th>

          <th colspan="2" class="th-text-center">
            Power Output (Rated)
          </th>

          <th rowspan="3" mat-sort-header="distance_travelled">
            Distance Travelled
          </th>

          <th rowspan="3" mat-sort-header="hours_underway">
            Hours Underway
          </th>

          <th colspan="4" class="th-text-center">
            Fuel Consumption
          </th>

          <th rowspan="3" class="th-text-center">
            Generate Report
          </th>
        </tr>

        <!-- SUB HEADER -->
        <tr class="sub-header">
          <th mat-sort-header="main_engine_power">Main Engine</th>
          <th mat-sort-header="aux_engine_power">Aux Engine</th>

          <th>HFO</th>
          <th>LFO</th>
          <th>Diesel / Gas Oil</th>
          <th>LNG</th>
        </tr>

        <!-- CF HEADER -->
        <tr class="cf-header">
          <th></th>
          <th></th>

          <th>(Cf: 3.114)</th>
          <th>(Cf: 3.151)</th>
          <th>(Cf: 3.206)</th>
          <th>(Cf: 2.750)</th>
        </tr>

      </thead>

      <!-- ================= BODY ================= -->
      <tbody>
        <ng-container *ngIf="isLoading; else dataRows">
          <tr *ngFor="let i of [1,2,3,4,5]">
            <td [attr.colspan]="isMeraki ? 19 : 18">
              <div class="skeleton-table-row skeleton"></div>
            </td>
          </tr>
        </ng-container>

        <ng-template #dataRows>
          <tr *ngFor="let element of paginatedData; let rowIndex = index">

            <td>{{ rowIndex + 1 }}</td>

            <td class="left">{{ element.vessel_name || '-' }}</td>
            <td *ngIf="isMeraki">{{ formatStartDate(element.start_date) }}</td>
            <td class="left">{{ element.imo_number || '-' }}</td>
            <td class="left">{{ element.vessel_type || '-' }}</td>
            <td class="left">{{ element.segment || '-' }}</td>

            <td>{{ element.gross_tonnage | number:'1.0-0' || '-' }}</td>
            <td>{{ element.deadweight | number:'1.0-0' || '-' }}</td>
            <td>{{ element.ice_class || 'No' }}</td>

            <td>{{ formatEeoi(element.eeoi) }}</td>

            <td>{{ +element.main_engine_output ? (element.main_engine_output | number:'1.0-0') : '-' }}</td>
            <td>{{ +element.aux_engine_output ? (element.aux_engine_output | number:'1.0-0') : '-' }}</td>

            <td>{{ +element.distance_travelled ? (element.distance_travelled | number:'1.0-0') : '-' }}</td>
            <td>{{ +element.time_hours ? (element.time_hours | number:'1.0-0') : '-' }}</td>

            <td>{{ +element.fuel_hfo ? (element.fuel_hfo | number:'1.0-2') : '-' }}</td>
            <td>{{ +element.fuel_lfo ? (element.fuel_lfo | number:'1.0-2') : '-' }}</td>
            <td>{{ +element.fuel_mgo ? (element.fuel_mgo | number:'1.0-2') : '-' }}</td>
            <td>{{ +element.fuel_lng ? (element.fuel_lng | number:'1.0-2') : '-' }}</td>

            <td class="text-center">
              <mat-icon matTooltip="Generate IMO DCS Report" (click)="openGenerateReportPopup(element)"
                style="cursor:pointer; font-size:22px">
                description
              </mat-icon>
            </td>

          </tr>
          <tr *ngIf="paginatedData.length === 0">
            <td [attr.colspan]="isMeraki ? 19 : 18" style="text-align: center; padding: 20px; color: #718096;">
              No records found for the selected filters.
            </td>
          </tr>
        </ng-template>
      </tbody>

    </table>
  </div>





  <mat-paginator [length]="elements.length" [pageSize]="itemsPerPage" [pageSizeOptions]="[100]"
    (page)="onPageChange($event)" [ngClass]="{ 'dark-paginator': isDarkMode() }" showFirstLastButtons>
  </mat-paginator>

  <div class="text-right">
    <button class="btn btn-light hover-button mail" (click)="downloadClick()">
      <mat-icon>download</mat-icon>&nbsp; Export
    </button>
  </div>

</div>

<br />